import { StyleSheet, Text, View } from '@react-pdf/renderer'

import { MeasuresPDFProps } from '..'

export const scoresPDFStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    marginVertical: 20,
  },
  box: {
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#dee2e6',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '33%',
    padding: 10,
    height: 82,
    position: 'relative',
  },
  title: {
    color: '#6b7280',
    fontSize: 10,
  },
  score: {
    color: '#041433',
    fontSize: 24,
    fontWeight: 600,
  },
  level: {
    position: 'absolute',
    bottom: 6,
    right: 6,
    borderRadius: 14,
    fontSize: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    fontWeight: 600,
  },
})

export const MeasuresPDFScores = ({
  latestScore,
  average,
  totalAssessments,
  level,
}: MeasuresPDFProps) => (
  <View style={scoresPDFStyles.container}>
    <View style={scoresPDFStyles.box}>
      <Text style={scoresPDFStyles.title}>Latest Score</Text>
      <Text style={scoresPDFStyles.score}>{latestScore}</Text>
      <View
        style={[
          scoresPDFStyles.level,
          { backgroundColor: `${level?.color}30`, color: level?.color },
        ]}
      >
        <Text style={{ color: level?.color }}>{level?.label}</Text>
      </View>
    </View>
    <View style={scoresPDFStyles.box}>
      <Text style={scoresPDFStyles.title}>Average</Text>
      <Text style={scoresPDFStyles.score}>{average}</Text>
    </View>
    <View style={scoresPDFStyles.box}>
      <Text style={scoresPDFStyles.title}>Total Assessments</Text>
      <Text style={scoresPDFStyles.score}>{totalAssessments}</Text>
    </View>
  </View>
)
